"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../../theme");
var COLUMN_ACTIVE_STYLE = function (style) {
    var opacity = style.opacity || 1;
    return { opacity: opacity * 0.5 };
};
var COLUMN_DISABLE_STYLE = function (style) {
    var opacity = style.opacity || 1;
    return { opacity: opacity * 0.5, fillOpacity: opacity * 0.5 };
};
theme_1.registerTheme('column', {
    columnStyle: {
        normal: {},
        active: COLUMN_ACTIVE_STYLE,
        disable: COLUMN_DISABLE_STYLE,
        selected: { lineWidth: 1, stroke: 'black' },
    },
});
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/column/theme.js
// module id = 892
// module chunks = 37